import { render, staticRenderFns } from "./PointListHistoryLayout.vue?vue&type=template&id=f96770b6&scoped=true&"
import script from "./PointListHistoryLayout.vue?vue&type=script&lang=js&"
export * from "./PointListHistoryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96770b6",
  null
  
)

export default component.exports